import justValidate from 'just-validate';

export function validateEntryForms() {
	'use strict';

	const form = document?.querySelector('.entry__form');

	if (form) {
		const validateEntryForm = new justValidate('.entry__form');

		validateEntryForm
			.addField('.input-login', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			])
			.addField('.input-password', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			]);
	}
}

export function validateCardFreeze() {
	'use strict';

	const form = document?.querySelector('.card-freeze__form');

	if (form) {
		const validateCardFreezeForm = new justValidate('.card-freeze__form');

		validateCardFreezeForm
			.addField('.input-date--one', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			])
			.addField('.input-date--two', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			]);
	}
}

export function validateChangePassword() {
	'use strict';

	const form = document?.querySelector('.change-password__form');

	if (form) {
		const validateChangePasswordForm = new justValidate('.change-password__form');

		validateChangePasswordForm
			.addField('.input-text', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			])
			.addField('.input-password--new', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			])
			.addField('.input-password--new-repeat', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			]);
	}
}

export function validateEditProfile() {
	'use strict';

	const form = document?.querySelector('.edit-profile__form');

	if (form) {
		const validateEditProfileForm = new justValidate('.edit-profile__form');

		validateEditProfileForm
			.addField('.input-email', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				},
				{
					rule: 'email',
					errorMessage: 'Ошибка'
				},
			]);
	}
}

export function validateEnterPassword() {
	'use strict';

	const form = document?.querySelector('.enter-password__form');

	if (form) {
		const validateEnterPasswordForm = new justValidate('.enter-password__form');

		validateEnterPasswordForm
			.addField('.input-text', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			]);
	}
}

export function validatePayment() {
	'use strict';

	const form = document?.querySelector('.payment-form__form');

	if (form) {
		const validatePaymentForm = new justValidate('.payment-form__form');

		validatePaymentForm
			.addField('.input-name', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			])
			.addField('.input-number-card', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			])
			.addField('.input-mounth', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			])
			.addField('.input-year', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				},
			])
			.addField('.input-cvc', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				},
			])
			.addField('.input-email', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				},
				{
					rule: 'email',
					errorMessage: 'Ошибка'
				},
			]);
	}
}

export function validateRestorePassword() {
	'use strict';

	const form = document?.querySelector('.restore-password__form');

	if (form) {
		const validateResrorePasswordForm = new justValidate('.restore-password__form');

		validateResrorePasswordForm
			.addField('.input-phone', [
				{
					rule: 'required',
					errorMessage: 'Ошибка'
				}
			]);
	}
}
